import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Loading from './Loading';
import * as Constants from '../Constants';
import {
  BodyContentVideo,
  Button,
  Container,
  ContainerVideos,
  ContentButton,
  ContentVideo,
  HeaderUpload,
  Thumb,
} from './UploadStyles';

const Upload = (props) => {
  const userInfo = useSelector((state) => state.auth.auth.user.username);
  const [showLoading, setShowLoading] = useState(true);
  const [uploads, setuploads] = useState([]);

  const handleDeleteVideo = (videoId) => {
    if (window.confirm("Tem certeza de que deseja deletar este vídeo?")) {
      axios
        .delete(`${Constants.api}/videoscube/api/video/${videoId}/`)
        .then((response) => {
          // Atualiza a lista de vídeos removendo o deletado
          setuploads((prevUploads) => prevUploads.filter((video) => video.id !== videoId));
          alert("Vídeo deletado com sucesso!");
        })
        .catch((error) => {
          console.error("Erro ao deletar o vídeo:", error);
          alert("Não foi possível deletar o vídeo. Tente novamente mais tarde.");
        });
    }
  };
  

  useEffect(() => {
    axios
      .get(`${Constants.api}/videoscube/api/channel/?user_id=${userInfo}`)
      .then((response) => {
        if (response.data.length) {
          axios
            .get(
              `${Constants.api}/videoscube/api/video/?channel__id=${
                props.ChannelId ? props.ChannelId : response.data[0].id
              }`
            )
            .then((videoResponse) => {
              if (videoResponse.data.data.length) {
                setuploads(videoResponse.data.data);
              } else {
                setShowLoading(false);
              }
            })
            .catch((error) => {
            });
        } else {
          setShowLoading(false);
        }
      })
      .catch((error) => {
      });
  }, [userInfo, props.ChannelId]);

  return (
    <Container>
      <HeaderUpload>
        <h3>Uploads</h3>
      </HeaderUpload>

      <ContainerVideos>
        {uploads.length ? (
          uploads.map((item, i) => {
            return (
              <ContentVideo key={item.id}>
                <Thumb>
                  <img src={item.thumbnail} />
                </Thumb>
                <BodyContentVideo>
                  <h4>{item.title}</h4>

                  <span>{item.channelTitle}</span>

                  <span>
                    <span>{item.view.length}</span> Views &nbsp;&nbsp;•&nbsp;
                    {(() => {
                      const date = new Date(`${item.date}`);
                      return Constants.timeAgo.format(date);
                    })()}
                  </span>
                </BodyContentVideo>
                <ContentButton>
                  <Button title="Assistir">Assistir</Button> |{' '}
                  <Button title="Deletar" onClick={() => handleDeleteVideo(item.id)}>Deletar</Button>
                </ContentButton>
              </ContentVideo>
            );
          })
        ) : (
          <>{showLoading ? <Loading /> : ''}</>
        )}
      </ContainerVideos>
    </Container>
  );
};

export default Upload;
